// extracted by mini-css-extract-plugin
export var buttonContainer = "_5h-1";
export var fontSizeSelect = "_5h-3";
export var formatSelect = "_5h-2";
export var formats = "_5h-4";
export var hidden = "_5h-5";
export var icon = "_5h-6";
export var select = "_5h-0";